import {
  ApplicationCalculationsSubscriptionDocument,
  ExpensesCalculationsSubscriptionDocument,
  OfferCalculationsSubscriptionDocument,
  TitleCalculationsSubscriptionDocument,
  TradelinesCalculationsSubscriptionDocument,
  ValuationsCalculationsSubscriptionDocument,
  api as generatedApi,
} from '@/graphql/generated'
import { GraphQLSubscription } from '@/utils/GraphQLSubscription'
import { PatchCollection, Recipe } from '@reduxjs/toolkit/dist/query/core/buildThunks'

const applicationCalcsSubscribe = async (
  externalId: string,
  query: string,
  queryName: string,
  subscriptionName: string,
  updateCachedData: (updateRecipe: Recipe<any>) => PatchCollection
) => {
  try {
    GraphQLSubscription.connect()

    const variables = {
      externalId: externalId,
    }

    const cacheInvalidationHandler = async (message) => {
      if (message?.payload?.data && subscriptionName in message?.payload?.data)
        updateCachedData((draft) => {
          const data = { application: {} }

          data.application[queryName] = message.payload.data[subscriptionName]
          if (draft && data) Object.assign(draft, data)
        })
    }

    GraphQLSubscription.subscribe(query, variables, cacheInvalidationHandler)
  } catch (error) {
    console.error(error)
  }
}

export const offerApi = generatedApi.enhanceEndpoints({
  endpoints: {
    getApplicationOfferCalcs: {
      providesTags: ['gql:applicationOfferCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          OfferCalculationsSubscriptionDocument,
          'offerCalculations',
          'offerCalculationsSubscription',
          updateCachedData
        )
      },
    },
    getApplicationCalcs: {
      providesTags: ['gql:applicationCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          ApplicationCalculationsSubscriptionDocument,
          'applicationCalculations',
          'applicationCalculationsSubscription',
          updateCachedData
        )
      },
    },
    getApplicationExpensesCalcs: {
      providesTags: ['gql:applicationExpensesCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          ExpensesCalculationsSubscriptionDocument,
          'expensesCalculations',
          'expensesCalculationsSubscription',
          updateCachedData
        )
      },
    },
    getApplicationTitleCalcs: {
      providesTags: ['gql:applicationTitleCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          TitleCalculationsSubscriptionDocument,
          'titleCalculations',
          'titleCalculationsSubscription',
          updateCachedData
        )
      },
    },
    getApplicationTradelinesCalcs: {
      providesTags: ['gql:applicationTradelinesCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          TradelinesCalculationsSubscriptionDocument,
          'tradelinesCalculations',
          'tradelinesCalculationsSubscription',
          updateCachedData
        )
      },
    },
    getApplicationValuationsCalcs: {
      providesTags: ['gql:applicationValuationsCalcs'],
      async onCacheEntryAdded(arg, { updateCachedData }) {
        applicationCalcsSubscribe(
          arg?.externalId,
          ValuationsCalculationsSubscriptionDocument,
          'valuationsCalculations',
          'valuationsCalculationsSubscription',
          updateCachedData
        )
      },
    },
  },
})

export const {
  useGetApplicationOfferCalcsQuery,
  useLazyGetApplicationOfferCalcsQuery,
  useGetApplicationCalcsQuery,
  useLazyGetApplicationCalcsQuery,
  useGetApplicationExpensesCalcsQuery,
  useLazyGetApplicationExpensesCalcsQuery,
  useGetApplicationTitleCalcsQuery,
  useLazyGetApplicationTitleCalcsQuery,
  useGetApplicationTradelinesCalcsQuery,
  useLazyGetApplicationTradelinesCalcsQuery,
  useGetApplicationValuationsCalcsQuery,
  useLazyGetApplicationValuationsCalcsQuery,
} = offerApi
